module.exports = __webpack_public_path__ + "static/media/medicConsult.256f8c5f.svg";